/**
 * Composant ProgrammeDialog - Dialogue pour télécharger/envoyer le programme de formation
 */

import { Button } from '../../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { BookOpen, Send, Download } from 'lucide-react';

export const ProgrammeDialog = ({
  open,
  onOpenChange,
  selectedProspect,
  onSendProgramme,
  onDownloadProgramme
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="programme-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <BookOpen className="h-5 w-5 text-[#8DC63F]" />
            Programme de formation
          </DialogTitle>
          <DialogDescription>
            Pour: {selectedProspect?.prenom} {selectedProspect?.nom}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-sm text-slate-600">
            Vous pouvez télécharger ou envoyer par email le programme de formation BPJEPS Motonautisme à ce prospect.
          </p>
          
          <div className="p-4 bg-slate-50 rounded-lg">
            <h4 className="font-medium text-slate-800 mb-2">Programme inclus :</h4>
            <ul className="text-sm text-slate-600 space-y-1">
              <li>• Objectifs pédagogiques</li>
              <li>• Contenu des blocs de compétences</li>
              <li>• Moyens pédagogiques</li>
              <li>• Modalités d'évaluation</li>
              <li>• Informations pratiques</li>
              <li>• Taux de réussite</li>
            </ul>
          </div>
        </div>
        
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button 
            variant="outline"
            onClick={onSendProgramme}
            className="border-blue-300 text-blue-600 hover:bg-blue-50"
            data-testid="send-programme-btn"
          >
            <Send className="h-4 w-4 mr-2" />
            Envoyer par email
          </Button>
          <Button 
            onClick={onDownloadProgramme}
            className="bg-[#8DC63F] hover:bg-[#7AB62F]"
            data-testid="download-programme-btn"
          >
            <Download className="h-4 w-4 mr-2" />
            Télécharger PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ProgrammeDialog;
